"use client";

import { GoogleTagManager } from "@next/third-parties/google";

import { clientEnv } from "../../../env.client";

export default function GoogleAnalyticsScripts() {
  return (
    <GoogleTagManager
      gtmId={clientEnv.NEXT_PUBLIC_GTM_KEY!}
      gtmScriptUrl={`${clientEnv.NEXT_PUBLIC_APP_URL}/gm`}
    />
  );
}
